import { useEffect, useRef, useState } from "react";
import { useScrollControl } from "../hook/ScrollContext";
import { BannerYoga, BannerMain, ImageBreath2, BannerSleep, BannerBreath, BannerLibrary, ImageMain, ImagYoga, ImageBreath, ImageLibrary, ArrowLeft, ArrowRight, BannerSleepMobile } from "../assets/images";
import { AnimatePresence, motion } from "framer-motion";
import Card from "../component/Card";

const Products = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [subIndex, setSubIndex] = useState(0);
    const { setScrollEnabled } = useScrollControl();
    const productsRef = useRef<HTMLDivElement>(null);
    const [indicatorStyle, setIndicatorStyle] = useState<any>({ width: 0, left: 0, height: 0, top: 0, translateY: 0 });
    const listImage = [ImageBreath, ImageBreath2]
    const contents = [
        <div className="space-y-4 max-lg:w-full" key={0}>
            <div className="max-lg:flex max-lg:gap-x-1 max-lg:px-4 max-lg:py-4 max-lg:rounded-3xl max-lg:bg-[#00000026] max-lg:backdrop-blur-[27.6]">
                <p className="text-[48px] max-lg:text-[24px] font-saira font-semibold text-white">Uncover Rare</p>
                <p className="text-[48px] max-lg:text-[24px] font-saira font-semibold text-white">Techniques</p>
            </div>
            <Card
                desc={
                    <p className="text-white font-sf font-thin text-[48px] max-lg:text-[24px]">
                        Explore <span className="font-bold">a unique collection</span> of powerful breathing exercises, carefully curated to unlock deeper calm, energy, and clarity.
                    </p>
                }
            />
        </div>,
        <div className="space-y-4" key={1}>
            <div className="max-lg:flex max-lg:gap-x-1 max-lg:px-4 max-lg:py-4 max-lg:rounded-3xl max-lg:bg-[#00000026] max-lg:backdrop-blur-[27.6]">
                <p className="text-[48px] max-lg:text-[24px] font-saira font-semibold text-white">Guided by</p>
                <p className="text-[48px] max-lg:text-[24px] font-saira font-semibold text-white">Masters</p>
            </div>
            <Card
                desc={
                    <p className="text-white font-sf font-thin text-[48px] max-lg:text-[24px]">
                        Learn and perfect each breath with the <span className="font-bold">warm, trustworthy voices</span> of professional instructors, ensuring precise guidance every step of the way.
                    </p>
                }
            />
        </div>
    ];

    const slides = [
        {
            id: 1,
            title: "Main",
            fragment: (
                <div className="col-span-full grid grid-cols-11 h-full items-start">
                    <div className="max-lg:col-span-full lg:col-start-2 col-span-5 lg:h-[750px] max-lg:h-[500px]">
                        <img src={ImageMain} className="w-full h-full object-contain" />
                    </div>
                    <div className="lg:col-span-5 max-lg:col-span-full grid grid-cols-2 lg:gap-x-[60px] gap-y-8 max-lg:px-4">
                        <div className="max-lg:col-span-full lg:col-span-1 h-fit">
                            <p className="text-[64px] max-lg:text-[32px] font-semibold font-saira text-white">Stress relief</p>
                            <Card
                                desc={
                                    (
                                        <div className="space-y-4">
                                            <p className="font-sf text-white text-[16px] italic font-thin "><span className="font-bold not-italic">Instant Calm: </span> Melt away tension with soothing natural soundscapes.</p>
                                            <p className="font-sf text-white text-[16px] italic font-thin "><span className="font-bold not-italic">Your Sonic Sanctuary: </span> Find immediate peace and quiet amidst the noise.</p>
                                        </div>
                                    )
                                }
                            />
                        </div>
                        <div className="max-lg:col-span-full lg:col-span-1 h-fit">
                            <p className="text-[64px] max-lg:text-[32px] font-semibold font-saira text-white">Focus</p>
                            <Card
                                desc={
                                    (
                                        <div className="space-y-4">
                                            <p className="font-sf text-white text-[16px] italic font-thin "><span className="font-bold not-italic">Sharpen Your Mind: </span> Cultivate clear concentration naturally.</p>
                                            <p className="font-sf text-white text-[16px] italic font-thin "><span className="font-bold not-italic">Deep Work Flow: </span> Eliminate distractions and boost productivity. </p>
                                        </div>
                                    )
                                }
                            />
                        </div>
                        <div className="max-lg:col-span-full lg:col-span-1 h-fit">
                            <p className="text-[64px] max-lg:text-[32px] font-semibold font-saira text-white">Sleep</p>
                            <Card
                                desc={
                                    (
                                        <div className="space-y-4">
                                            <p className="font-sf text-white text-[16px] italic font-thin "><span className="font-bold not-italic">Restful Nights:  </span> Drift into deep, restorative sleep.</p>
                                            <p className="font-sf text-white text-[16px] italic font-thin "><span className="font-bold not-italic">Naturally Unwind: </span> Gentle sounds and stories for peaceful slumber.</p>
                                        </div>
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
            ),
            banner: BannerMain,
        },
        {
            id: 2,
            title: "Simple",
            fragment: (
                <div className="w-full grid grid-cols-11 max-lg:px-4 items-center max-lg:h-full">
                    <div className="col-span-2 lg:col-start-9 max-lg:col-span-full max-lg:bg-[#00000026] max-lg:backdrop-blur-[27.6] max-lg:rounded-3xl max-lg:px-2 max-lg:py-4">
                        <p className="lg:text-[60px] text-[32px] font-semibold text-white font-saira">
                            Simple Interaction,
                        </p>
                        <p className="lg:text-[48px] text-[32px] font-thin text-white font-saira">
                            Seamless Serenity. Your perfect calm continues to play, even when your screen is off
                        </p>
                    </div>
                </div>
            ),
            banner: window.innerWidth > 1024 ? BannerSleep : BannerSleepMobile,
        },
        {
            id: 3,
            title: "Yoga",
            fragment: (
                <div className="col-span-full grid grid-cols-11 h-full items-start lg:gap-x-12">
                    <div className="lg:col-start-2 max-lg:col-span-full lg:col-span-5 lg:h-[740px] max-lg:h-[327px] max-lg:mt-8">
                        <img src={ImagYoga} className="object-contain h-full w-full" />
                    </div>
                    <div className="max-lg:col-span-full lg:col-span-5 lg:space-y-4 max-lg:space-y-2 max-lg:px-4">
                        <p className="text-[48px] max-lg:text-[32px] font-saira font-semibold text-white">Flow Freely</p>
                        <p className="text-[48px] max-lg:text-[32px] font-saira font-semibold text-white">Learn from Masters</p>
                        <div className="space-y-4 lg:ml-[-16px]">
                            <div className="px-2 max-lg:py-2 lg:py-4 bg-[#8AC028] text-[48px] max-lg:text-[32px] font-saira font-semibold text-white h-[70px] flex items-center max-lg:w-fit lg:max-w-[200px]">Anytime</div>
                            <div className="px-2 max-lg:py-2 lg:py-4 bg-[#8AC028] text-[48px] max-lg:text-[32px] font-saira font-semibold text-white h-[70px] flex items-center max-lg:w-fit lg:max-w-[400px]">Anywhere</div>
                        </div>
                    </div>
                </div>
            ),
            banner: BannerYoga
        },
        {
            id: 4,
            title: "Breath",
            fragment: (
                <div className="col-span-full grid grid-cols-11 h-full items-start lg:gap-x-12">
                    <div className="lg:col-span-3 col-span-full lg:h-[760px] max-lg:h-[540px] lg:col-start-2 max-lg:mt-8">
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={subIndex}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.6, ease: "easeInOut" }}
                                className="w-full max-lg:h-full"
                            >
                                <img src={listImage[subIndex]} className="object-contain h-full max-lg:mx-auto" />
                            </motion.div>
                        </AnimatePresence>
                    </div>
                    <div className="max-lg:col-span-full max-lg:px-4 lg:col-span-7 lg:space-y-10 max-lg:space-y-4">
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={subIndex}
                                initial={{ x: 100, opacity: 0 }}
                                animate={{ x: 0, opacity: 1 }}
                                exit={{ x: -100, opacity: 0 }}
                                transition={{ duration: 0.6, ease: "easeInOut" }}
                                className="w-full"
                            >
                                {contents[subIndex]}
                            </motion.div>
                        </AnimatePresence>
                        <div className="flex items-center justify-between max-lg:gap-x-12">
                            <div onClick={() => { handlePrev() }} className="cursor-pointer space-y-4 max-lg:space-y-2">
                                <img src={ArrowLeft} />
                                <p className="text-[40px] max-lg:text-[24px] text-white font-semibold font-saira">Previous</p>
                            </div>
                            <div onClick={() => { handleNext() }} className="cursor-pointer space-y-4 max-lg:space-y-2">
                                <img src={ArrowRight} />
                                <p className="text-[40px] max-lg:text-[24px] text-white font-semibold font-saira text-right">Next</p>
                            </div>
                        </div>
                    </div>
                </div>
            ),
            banner: BannerBreath
        },
        {
            id: 5,
            title: "Library",
            fragment: (
                <div className="col-span-full grid grid-cols-11 h-full items-center gap-x-5 max-lg:px-4">
                    <div className="col-start-2 lg:col-span-5 lg:h-[730px] max-lg:h-[440px] max-lg:col-span-full">
                        <img src={ImageLibrary} className="object-contain h-full w-full" />
                    </div>
                    <div className="col-span-5 space-y-5 max-lg:col-span-full">
                        <div className="text-[64px] max-lg:text-[32px] font-semibold text-white font-saira px-8 py-4 rounded-full bg-[#00000026] backdrop-blur-[50] w-fit max-lg:mx-auto">
                            Explore Unlimited
                        </div>
                        <div className="text-[80px] max-lg:text-[48px] font-normal text-white font-ms px-8 py-4 rounded-full bg-gradient w-fit max-lg:mx-auto">
                            Premium Audio
                        </div>
                    </div>
                </div>
            ),
            banner: BannerLibrary
        },
    ]
    const triggerOuterScroll = (direction: 'up' | 'down') => {
        const deltaY = direction === 'down' ? 100 : -100;
        const fakeWheelEvent = new WheelEvent('wheel', { deltaY });
        window.dispatchEvent(fakeWheelEvent);
    };

    const handlePrev = () => {
        if (subIndex > 0) setSubIndex(subIndex - 1);
    };

    const handleNext = () => {
        if (subIndex < contents.length - 1) setSubIndex(subIndex + 1);
    };

    useEffect(() => {
        const container = productsRef.current;
        if (!container) return;
        if (window.innerWidth < 1024) return;

        let timeout: NodeJS.Timeout | null = null;

        const handleSectionScroll = (e: WheelEvent) => {
            e.preventDefault();
            e.stopPropagation();

            const goingDown = e.deltaY > 0;
            const nextIndex = goingDown ? activeIndex + 1 : activeIndex - 1;

            if (goingDown) {
                if (nextIndex < slides.length) {
                    setScrollEnabled(false);
                    setActiveIndex(nextIndex);
                    if (nextIndex === slides.length - 1) {
                        setScrollEnabled(true);
                        triggerOuterScroll('down');
                    }
                } else {
                    setScrollEnabled(true);
                    triggerOuterScroll('down');
                }
            } else {
                if (nextIndex >= 0) {
                    setScrollEnabled(false);
                    setActiveIndex(nextIndex);
                    if (nextIndex === 0) {
                        setScrollEnabled(true);
                        triggerOuterScroll('up');
                    }
                } else {
                    setScrollEnabled(true);
                    triggerOuterScroll('up');
                }
            }
        };
        container.addEventListener("wheel", handleSectionScroll, { passive: false });
        return () => {
            container.removeEventListener("wheel", handleSectionScroll);
            if (timeout) clearTimeout(timeout);
        };
    }, [activeIndex, slides.length, setScrollEnabled]);

    const [loaded, setLoaded] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(slides[0]);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setLoaded(false);
        setCurrentSlide(slides[activeIndex]);
        const container = containerRef.current;
        if (container) {
            const tab = container.children[activeIndex] as HTMLDivElement;
            if (tab) {
                const rect = tab.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                const centerY = rect.top - containerRect.top + rect.height / 2;
                setIndicatorStyle({
                    translateY: centerY,
                    height: rect.height,
                });
            }
        }
    }, [activeIndex]);



    return (
        <div className="w-full h-full relative bg-[#000000] bg-opacity-80 lg:px-10" ref={productsRef}>
            <AnimatePresence mode="wait">
                <motion.img
                    key={currentSlide.id}
                    src={currentSlide.banner}
                    onLoad={() => setLoaded(true)}
                    initial={{ opacity: 0, filter: "blur(20px)", scale: 1.03 }}
                    animate={{
                        opacity: loaded ? 1 : 0,
                        filter: loaded ? "blur(0px)" : "blur(20px)",
                        scale: 1,
                    }}
                    exit={{ opacity: 0, filter: "blur(20px)", scale: 1.03 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                    className="absolute inset-0 w-full h-full object-cover z-0"
                />
            </AnimatePresence>
            <div className="lg:grid lg:grid-cols-12 gap-y-4 lg:h-[calc(100%-60px)] pt-[120px] absolute z-1 lg:gap-x-[20px] w-full max-lg:h-[calc(100%-130px)]">
                <div ref={containerRef} className="max-lg:bg-[#FFFFFF26] max-lg:justify-center max-lg:backdrop-blur-[27.6] max-lg:items-center lg:col-span-1 col-span-full lg:space-y-4 max-lg:flex max-lg:overflow-x-auto max-lg:gap-x-8 max-lg:whitespace-nowrap max-lg:no-scrollbar max-lg:py-4 lg:h-fit relative">
                    {slides.map((slide, index) => (
                        <div
                            key={slide.title}
                            onClick={() => setActiveIndex(index)}
                            className={`cursor-pointer inline-block max-lg:min-w-max lg:w-full text-right font-saira ${activeIndex === index
                                ? "text-white lg:text-[60px] text-[24px] font-semibold"
                                : "duration-500 ease-linear lg:text-[48px] text-[16px] backdrop-blur-xs text-white font-light"
                                }`}
                        >
                            {slide.title}
                        </div>
                    ))}
                    <div
                        className="absolute lg:flex hidden top-0 pointer-events-none transition-all duration-500 ease-in-out -right-[40px] w-[20px] items-center justify-center "
                        style={{
                            top: `${activeIndex * 96 - activeIndex * 8}px`,
                            height: `${indicatorStyle.height - 16}px`,
                        }}
                    >
                        <div className="left-full w-[20px] h-[2px] bg-white rounded-2xl" />
                    </div>
                </div>
                <div className="lg:col-span-10 col-span-full max-lg:py-4 relative overflow-hidden max-lg:h-full max-lg:overflow-y-scroll">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={activeIndex}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.5, ease: "easeInOut" }}
                            className="absolute inset-0 w-full h-full"
                        >
                            {slides[activeIndex].fragment}
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>
        </div>

    );
}
export default Products;